<script lang="ts">
import ModuleMarketing from '@/generated/modules/ModuleMarketing.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleMarketing
})

</script>
